import { orgInfoProxy } from './index';
// proxy/org/info/1.0/

/* [ 조직, 조직도 ] */
// 조직정보 목록조회
function getOrgInfoList(params) {
  return orgInfoProxy.get('search/list', { params });
}

// 조직정보 트리목록조회
function getOrgInfoTreeList(params) {
  return orgInfoProxy.get('search/tree/list', { params });
}

export { getOrgInfoList, getOrgInfoTreeList };
